import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	mode: 'history',
	base: '/harbourspirits2026/',
	routes: [
		{path: '/',redirect:'index'},
		// {path: '/index',component:()=>import("./pages/index3.vue"),name:"首页"},
		// {path: '/redeem',component:()=>import("./pages/index2.vue"),name:"兑换中心"},
		{path: '/store',component:()=>import("./pages/index1.vue"),name:"门店"},
		// {path: '/bar-hopping',component:()=>import("./pages/index4.vue"),name:"酒吧地图"},
		{path: '/bar-map',component:()=>import("./pages/barMap.vue"),name:"酒吧地圖"},
		{path: '/bar-store/:storeId',component:()=>import("./pages/barStore.vue"),name:"酒吧門店"},
		// {path: '/store-map',component:()=>import("./pages/index5.vue"),name:"门店地图"},
		{path: '/index',component:()=>import("./pages/harbour.vue"),name:"Harbour Spirits 酒吧巡禮"},
		{path: '/schedule',component:()=>import("./pages/schedule.vue"),name:"活动日程"},
		{path: '/history-map',component:()=>import("./pages/historyMap.vue"),name:"歷史穿越地圖"},
		
	]
})